var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"pages"}},[_c('router-view',{key:_vm.$route.path,on:{"setAppClasses":_vm.setAppClasses}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }